<div class="modal-header">
    <h4 class="modal-title">{{name}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="InputSubstationNumber">Number:</label>
        <input type="text" class="form-control" id="InputSubstationNumber" placeholder="Enter Substation Number" value={{substation.substation_number}}>
      </div>
      <div class="form-group">
        <div class="in-line">
          <label for="InputSubstationName">Name:</label>
        </div>
        <input type="text" class="form-control" id="InputSubstationName" aria-describedby="substationNameHelp" placeholder="Enter Substation Name" value={{substation.substation_name}}>
      </div>
      <span>
        <input type="checkbox" name="rebroadcast0" id="rebroadcast0" value="rebroadcast0"> <strong>Make Inactive</strong>
      </span>
      <div class="form-group" style="font-size:14px;">
        <div class="input-group">
          <label>Event End Date:</label>&nbsp;
          <input id="endDate" class="form-control" placeholder="yyyy-mm-dd" name="ass" ngbDatepicker #dp="ngbDatepicker">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary fa fa-calendar" (click)="dp.toggle()" type="button"></button>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="tx1Menu">T1: </label>
        <div ngbDropdown class="d-inline-block">
          <button class="btn btn-outline-primary" id="tx1Menu" ngbDropdownToggle>{{selectedTX1Option}}</button>
          <div class="dropdown-menu" aria-labelledby="tx1Menu" ngbDropdownMenu>
            <button class="dropdown-item" *ngFor="let tx1Option of tx1Options" (click)="ChangeTX1Option(tx1Option)">{{tx1Option}}</button>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="tx2Menu">T2: </label>
        <div ngbDropdown class="d-inline-block">
          <button class="btn btn-outline-primary" id="tx2Menu" ngbDropdownToggle>{{selectedTX2Option}}</button>
          <div class="dropdown-menu" aria-labelledby="tx2Menu" ngbDropdownMenu>
            <button class="dropdown-item" *ngFor="let tx2Option of tx2Options" (click)="ChangeTX2Option(tx2Option)">{{tx2Option}}</button>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="tx3Menu">T3: </label>
        <div ngbDropdown class="d-inline-block">
          <button class="btn btn-outline-primary" id="tx3Menu" ngbDropdownToggle>{{selectedTX3Option}}</button>
          <div class="dropdown-menu" aria-labelledby="tx3Menu" ngbDropdownMenu>
            <button class="dropdown-item" *ngFor="let tx3Option of tx3Options" (click)="ChangeTX3Option(tx3Option)">{{tx3Option}}</button>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="tx4Menu">T4: </label>
        <div ngbDropdown class="d-inline-block">
          <button class="btn btn-outline-primary" id="tx4Menu" ngbDropdownToggle>{{selectedTX4Option}}</button>
          <div class="dropdown-menu" aria-labelledby="tx4Menu" ngbDropdownMenu>
            <button class="dropdown-item" *ngFor="let tx4Option of tx4Options" (click)="ChangeTX4Option(tx4Option)">{{tx4Option}}</button>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="tx5Menu">T5: </label>
        <div ngbDropdown class="d-inline-block">
          <button class="btn btn-outline-primary" id="tx5Menu" ngbDropdownToggle>{{selectedTX5Option}}</button>
          <div class="dropdown-menu" aria-labelledby="tx5Menu" ngbDropdownMenu>
            <button class="dropdown-item" *ngFor="let tx5Option of tx5Options" (click)="ChangeTX5Option(tx5Option)">{{tx5Option}}</button>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="tx6Menu">T6: </label>
        <div ngbDropdown class="d-inline-block">
          <button class="btn btn-outline-primary" id="tx6Menu" ngbDropdownToggle>{{selectedTX6Option}}</button>
          <div class="dropdown-menu" aria-labelledby="tx6Menu" ngbDropdownMenu>
            <button class="dropdown-item" *ngFor="let tx6Option of tx6Options" (click)="ChangeTX6Option(tx6Option)">{{tx6Option}}</button>
          </div>
        </div>
      </div>
    </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="activeModal.close('Close click')">Save</button>
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Cancel click')">Cancel</button>
</div>
